SWR.Social.prototype._loadMastodon = function _loadMastodon(EVENT_KEY, DATA_API_KEY) {
  var self = this;
  var embedFrameId = COMMON.Utils.uuid();
  var embedUrl = new URL(self.config.url);
  embedUrl.searchParams = new URLSearchParams();

  var pathnameParts = embedUrl.pathname.split('/');
  pathnameParts.push('embed');
  embedUrl.pathname = pathnameParts.join('/');

  //Iframe mit Resize
  try {
    var html = COMMON.Utils.template('<div class="embed-responsive embed-responsive-dynamic"><iframe src="{src}" id="{id}" class="embed-responsive-item" allowfullscreen="allowfullscreen"></iframe></div>', {
      src: embedUrl.toString(),
      id: embedFrameId
    });

    self._done(html);

    var embedFrame = document.getElementById(embedFrameId);

    if (!window.mastodonIframes) {
      window.mastodonIframes = new Map();
    }
    window.mastodonIframes.set(embedFrameId, embedFrame);

    embedFrame.onload = function () {
      postHeightUpdate(embedFrameId);
    };

    ready(function () {
      embedFrame.scrolling = 'no';
      embedFrame.style.overflow = 'hidden';
      postHeightUpdate(embedFrameId);
    });

    resize(embedFrame, embedFrameId, EVENT_KEY, DATA_API_KEY);

  } catch (exception) {
    self._failed(self.config.embedCookie, self.url);
  }

  $(document).one('pjax:beforeReplace' + EVENT_KEY + DATA_API_KEY, function () {
    if (window.mastodonIframes.has(embedFrameId)) {
      window.mastodonIframes.delete(embedFrameId);
    }
  });
};

function postHeightUpdate(embedFrameId) {
  var embedFrame = window.mastodonIframes.get(embedFrameId);
  if (embedFrame && embedFrame.contentWindow) {
    embedFrame.contentWindow.postMessage({
      type: 'setHeight',
      id: embedFrameId
    }, '*');
  }
}

SWR.Social.prototype._loadMastodonSDK = function _loadMastodonSDK() {

  if (typeof window.mastodonIframes !== 'undefined') {
    return;
  }

  /** @type {Map<number, HTMLIFrameElement>} */
  window.mastodonIframes = new Map();

  window.addEventListener('message', function (e) {
    var data = e.data || {};

    if (typeof data !== 'object' || data.type !== 'setHeight' || !window.mastodonIframes.has(data.id)) {
      return;
    }

    var iframe = window.mastodonIframes.get(data.id);
    if ('source' in e && iframe.contentWindow !== e.source) {
      return;
    }

    iframe.height = data.height;
  });
};

function ready(loaded) {
  if (document.readyState === 'complete') {
    loaded();
  } else {
    document.addEventListener('readystatechange', function () {
      if (document.readyState === 'complete') {
        loaded();
      }
    });
  }
}

function resize(embedFrame, embedFrameId, EVENT_KEY, DATA_API_KEY) {
  var repeatSetHeight = 3;

  /**
   * Je nach Geschwindigkeit der Internetverbindung braucht der iFrame etwas mit der Höhenanpassung
   * allerdings bekommen wir nur dann ein Update über die neue Höhe, wenn wir aktiv anfragen.
   *
   * @param {int} count
   * @returns {Promise<void>}
   */
  async function setHeight(count) {
    for (var i = 0; i < count; i++) {
      if (i === 0) {
        embedFrame.height = 150;
        await new Promise(function (resolve) {
          self.setHeightTimeout = window.setTimeout(resolve, 250);
        });
      }
      postHeightUpdate(embedFrameId);
      await new Promise(function (resolve) {
        self.setHeightTimeout = window.setTimeout(resolve, 250);
      });
    }
  }

  $(document).on('swr.grid' + EVENT_KEY + DATA_API_KEY, function () {
    if (self.setHeightTimeout) {
      window.clearTimeout(self.setHeightTimeout);
    }
    setHeight(repeatSetHeight);
  });
}
